import { Loading } from "@/components/ui";
import { Button } from "@paribus/shared-ui";
import { ArrowRight, CreditCard } from "lucide-react";

interface UpdatePaymentMethodBannerProps {
  onUpdatePaymentMethod: () => void | Promise<void>;
  isLoading?: boolean;
}

export const UpdatePaymentMethodBanner = ({
  onUpdatePaymentMethod,
  isLoading = false,
}: UpdatePaymentMethodBannerProps) => {
  return (
    <div className="container mx-auto px-4 pt-8">
      <div className="relative overflow-hidden rounded-2xl border border-destructive-border bg-gradient-to-r from-destructive-subtle/80 via-white to-destructive-subtle/80 p-6 shadow-sm transition-all hover:shadow-md">
        {/* Subtle background decoration */}
        <div className="absolute -right-8 -top-8 h-32 w-32 rounded-full bg-destructive-subtle-strong/40 blur-3xl" />
        <div className="absolute -bottom-8 -left-8 h-32 w-32 rounded-full bg-destructive-subtle-strong/40 blur-3xl" />

        <div className="relative flex flex-col gap-6 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-start gap-4 sm:items-center">
            <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-destructive-subtle-strong text-destructive-text shadow-inner">
              <CreditCard className="h-6 w-6" />
            </div>
            <div className="flex flex-col gap-0.5">
              <h3 className="text-base font-bold text-destructive-text">Outstanding Balance</h3>
              <p className="text-sm leading-relaxed text-destructive-text/80">
                You have a pending invoice that needs to be settled. Please update your payment
                method to resolve this balance and unlock new plan options.
              </p>
            </div>
          </div>

          <Button
            onClick={onUpdatePaymentMethod}
            disabled={isLoading}
            className="group w-full shrink-0 border-0 bg-destructive px-6 font-bold text-white transition-all hover:bg-destructive-hover hover:shadow-lg sm:w-auto"
            size="lg"
          >
            {isLoading ? (
              <div className="flex items-center gap-2">
                <Loading size={16} tone="inverse" fullScreen={false} />
                <span>Redirecting...</span>
              </div>
            ) : (
              <div className="flex items-center gap-2">
                <span>Pay Invoice</span>
                <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
              </div>
            )}
          </Button>
        </div>
      </div>
    </div>
  );
};
